const TOKEN_KEY = 'token';
const AUTH_PROVIDER_KEY = 'auth_provider';

function readFromStorage(key) {
  return sessionStorage.getItem(key) ?? localStorage.getItem(key);
}

function removeLegacyLocalStorage() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(AUTH_PROVIDER_KEY);
}

export function getStoredToken() {
  const token = readFromStorage(TOKEN_KEY);
  if (token && !sessionStorage.getItem(TOKEN_KEY)) {
    sessionStorage.setItem(TOKEN_KEY, token);
    removeLegacyLocalStorage();
  }
  return token;
}

export function getStoredAuthProvider() {
  const provider = readFromStorage(AUTH_PROVIDER_KEY);
  if (provider && !sessionStorage.getItem(AUTH_PROVIDER_KEY)) {
    sessionStorage.setItem(AUTH_PROVIDER_KEY, provider);
    removeLegacyLocalStorage();
  }
  return provider;
}

export function persistSession(accessToken, authProvider) {
  sessionStorage.setItem(TOKEN_KEY, accessToken);
  sessionStorage.setItem(AUTH_PROVIDER_KEY, authProvider);
  removeLegacyLocalStorage();
}

export function clearStoredSession() {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(AUTH_PROVIDER_KEY);
  removeLegacyLocalStorage();
}
